<template>
  <div>
    <b-form>
      <b-form-input v-model="query" placeholder="Buscar" type="search" autocomplete="off" @keydown.enter.prevent></b-form-input>
      <b-form-checkbox v-if="trashed" class="mt-2" v-model="withTrashed">
        Incluir colaboradores dados de baja
      </b-form-checkbox>
    </b-form>
    <hr />
    <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>
    <b-list-group>
      <b-list-group-item v-if="loadingResults" class="border-0 mb-2 shadow-sm">
        <svg class="w-6 h-6 mr-2 spinning" fill="none" stroke="currentColor" viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
          </path>
        </svg>
        <span>Cargando</span>
      </b-list-group-item>
      <b-list-group-item sm="12" md="12" lg="12" xl="12" class="pt-3" v-if="results.length === 0 && !loadingResults">

        <div class="text-center text-muted">
          <div class="p-3">
            <svg aria-hidden="true" x="0px" y="0px" width="80" height="80" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search fa-w-16 fa-6x"><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" class=""></path></svg>
          </div>
          <div class="p-3">
            Introduzca un nombre para buscar
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item v-else button v-for="result in results" :key="result.id" @click="$emit('input', result)"
        class="border-0 mb-2 shadow-sm">
        <img :src="result.avatar_full_path" :alt="result.names" class="w-8 h-8 mr-2 rounded-circle" />
        <span>{{ display(result) }}</span>
      </b-list-group-item>
      <b-list-group-item v-if="moreResultsAvailable" class="border-0 mb-2 shadow-sm">
        <a href="#" @click.prevent="loadMore">Cargar más ...</a>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      query: "",
      results: [],
      withTrashed: false,
      nextResults: null,
      loadingResults: false,
      cancelSearch: null,
      errorMessage: null,
    };
  },
  props: {
    trashed: {
      type: Boolean,
      default: false,
    },
    all: {
      type: Boolean,
      default: false,
    },
    without: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    moreResultsAvailable() {
      return this.nextResults != null && this.loadingResults === false;
    },
  },
  mounted() {
    if (!this.without) {
      this.findEmployee();
      this.withTrashed = this.all;
    }
  },
  methods: {
    findEmployee() {
      if (this.query.length < 3 && this.query.length > 0) return;
      var params = { quickSearch: this.query };
      if (this.withTrashed) params.withTrashed = true;
      var vm = this;
      if (this.cancelSearch !== null) this.cancelSearch();
      if (this.query.length === 0) {
        this.results = [];
        this.nextResults = null;
        return;
      }
      this.loadingResults = true;
      axios
        .get("/employees", {
          params: params,
          cancelToken: new axios.CancelToken(function executor(c) {
            vm.cancelSearch = c;
          }),
        })
        .then((resp) => {
          this.errorMessage = null;
          this.cancelSearch = null;
          this.results = resp.data.data.map((e) => {
            e.identify_group =
              e.identify_group != null ? "(" + e.identify_group + ")" : "";
            return e;
          });
          this.nextResults = resp.data.next_page_url;
          this.loadingResults = false;
        })
        .catch((resp) => {
          if (axios.isCancel(resp)) {
          } else {
            // alert("No fue posible actualizar los empleados")
            this.errorMessage = "Vuelva a realizar la busqueda.";
            console.log(resp);
          }
        });
    },
    loadMore() {
      this.loadingResults = true;
      axios
        .get(this.nextResults)
        .then((r) => {
          this.loadingResults = false;
          this.results = this.results.concat(r.data.data);
          this.nextResults = r.data.next_page_url;
        })
        .catch((r) => {
          console.log(r);
        });
    },
    display: (result) =>
      result.names + " (" + result.alias + ")" + " " + result.identify_group,
  },
  watch: {
    query(v) {
      this.findEmployee();
    },
    withTrashed(v) {
      this.findEmployee();
    },
  },
};
</script>
<style scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg) scaleX(-1);
  }

  100% {
    transform: rotate(360deg) scaleX(-1);
  }
}

.spinning {
  animation: spin 2s linear infinite;
}
</style>
